import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { Layout } from '@hydra/common/components';
import { ErrorBoundary } from '@hydra/common/error';
import { Shell } from '@hydra/types/shell';

interface LayoutShellProps extends Shell {
  sideNav?: boolean
  sideNavType?: string
}

export default function LayoutShell (props: LayoutShellProps) {
  const theme = useTheme();
  const {
    className,
    children,
    sideNav,
    sideNavType,
    bgColor = theme.palette.background.default
  } = props;

  return (
    <ErrorBoundary sideNav={sideNav}>
      <Layout
        sideNav={sideNav || false}
        sideNavType={sideNavType}
        bgColor={bgColor}
        className={className}
      >
        {children}
      </Layout>
    </ErrorBoundary>
  );
}
